module.exports = __webpack_public_path__ + "img/111.b43b6e90.jpg";